export default "__VITE_ASSET__CaYs5qeY__"